import type {ReactNode} from 'react'
import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {Container} from '@freckle/educator-materials/ts/components/container'
import {UnauthenticatedFooter} from '@freckle/educator-materials/ts/components/footer/unauthenticated-footer'
import {Image} from '@freckle/educator-materials/ts/components/img'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {centeredPage, logo, centeredPageContent} from './centered-page.module.scss'

type Props = {
  children: ReactNode
}

export function CenteredPage(p: Props) {
  const {t} = useSafeTranslation()

  return (
    <div className={centeredPage}>
      <Image
        src={`${PATHS.imageAssetsUrl}/company-logos/renaissance-freckle-logo.svg`}
        className={logo}
        alt={t('CENTERED_PAGE_IMG_LOGO_ALT')}
        title={t('CENTERED_PAGE_IMG_LOGO_TITLE')}
      />
      <Container className={centeredPageContent}>{p.children}</Container>
      <UnauthenticatedFooter />
    </div>
  )
}
